import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {
  CG_FORCED_THEME,
  CG_THEME_STORAGE_KEY,
} from './app/core/theming/theme.registry';

if (environment.production) {
  enableProdMode();
}

// Sabit temali build'lerde (TCOnPrem*) ThemeService henuz Angular DI
// tarafindan olusturulmadan (AppComponent constructor'a kadar) dogru temayi
// uygular; theme-init.js'in localStorage tahminine bagli kalinmaz, boylece
// yanlis tema ile kisa sureli gorsel "flash" riski de ortadan kalkar.
if (CG_FORCED_THEME) {
  document.documentElement.setAttribute('data-cg-theme', CG_FORCED_THEME);
  try {
    localStorage.setItem(CG_THEME_STORAGE_KEY, CG_FORCED_THEME);
  } catch {
    // storage erisilemezse sessiz gec (private mod vb.)
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
